import { render } from "./PasswordResetActivity.vue?vue&type=template&id=4450c1f0"
import script from "./PasswordResetActivity.vue?vue&type=script&lang=js"
export * from "./PasswordResetActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__